
import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import MarkerIcon from "./../assets/selected-club-location.svg"
import { Marker } from "react-leaflet";


const CustomMarker = ({ position, children }) => {

  const markerRef = useRef(null);

  useEffect(() => {
    if (markerRef.current) {
      markerRef.current.openPopup();
    }
  }, [position]);

  const customIcon = L.icon({
    iconUrl: MarkerIcon,
    iconSize: [50, 50],
    iconAnchor: [25, 0],
  });

  return (
      <Marker position={position} icon={customIcon} ref={markerRef}>
        {children}
      </Marker>
  );
};

export default CustomMarker;